export enum CLCRT {
  "DS003" = "DS003",
  "DS520" = "DS520",
  "PR005" = "PR005",
  "PR051" = "PR051",
  "DS001" = "DS001",
  "UTIME" = "UTIME",
  "DS458" = "DS458",
  "PR006" = "PR006",
  "PR061" = "PR061",
  "PR007" = "PR007",
  "PR008" = "PR008",
  "PR070" = "PR070",
  "DS002" = "DS002",
  "PR052" = "PR052",
  "PR013" = "PR013",
}

export enum SecurityProperty {
  "companyName" = "companyName",
  "name" = "name",
  "price" = "price",
  "id" = "id",
  "lastUpdateUTC" = "lastUpdateUTC",
  "isoCountry" = "isoCountry",
  "open" = "open",
  "high" = "high",
  "low" = "low",
  "volume" = "volume",
  "absoluteChange" = "absoluteChange",
  "percentChange1Day" = "percentChange1Day",
  "percentChange1Month" = "percentChange1Month",
  "percentChange1Year" = "percentChange1Year",
  "exchange" = "exchange",
}

export const CLCRT_FIELDS = {
  [SecurityProperty.companyName]: CLCRT.DS002,
  [SecurityProperty.name]: CLCRT.DS520,
  [SecurityProperty.price]: CLCRT.PR005,
  [SecurityProperty.id]: CLCRT.DS001,
  [SecurityProperty.lastUpdateUTC]: CLCRT.UTIME,
  [SecurityProperty.isoCountry]: CLCRT.DS458,
  [SecurityProperty.open]: CLCRT.PR006,
  [SecurityProperty.high]: CLCRT.PR007,
  [SecurityProperty.low]: CLCRT.PR008,
  [SecurityProperty.volume]: CLCRT.PR013,
  [SecurityProperty.absoluteChange]: CLCRT.PR051,
  [SecurityProperty.percentChange1Day]: CLCRT.PR052,
  [SecurityProperty.percentChange1Month]: CLCRT.PR061,
  [SecurityProperty.percentChange1Year]: CLCRT.PR070,
  [SecurityProperty.exchange]: CLCRT.DS003,
};

export enum DaperFinanceReferenceCriteria {
  "PERCENT_UP" = "PERCENT_UP",
  "PERCENT_DOWN" = "PERCENT_DOWN",
  "VOLUME" = "VOLUME",
}

/**
 * See {@link https://bbgithub.dev.bloomberg.com/MediaServices/content-service/blob/698e7db7744e20a868018da36a1228cd861844ee/lib/Constant.js#L3|Content Service}
 */
export enum DaperStorySite {
  gadfly = "gadfly",
  quicktake = "quicktake",
  bbiz = "bbiz",
  bpol = "bpol",
  cybersecurity = "cybersecurity",
  "climate-changed" = "climate-changed",
  businessweek = "businessweek",
  "special-issue" = "special-issue",
  "new-economy-forum" = "new-economy-forum",
  markets = "markets",
  bloomberg_app = "bloomberg_app",
  bview = "bview",
  business_week_app = "business_week_app",
  technology = "technology",
  pursuits = "pursuits",
  btv = "btv",
  apple_news = "apple_news",
  cojp = "cojp",
  sponsored = "sponsored",
  feeds = "feeds",
  socialflow = "socialflow",
  tictoc = "tictoc",
  hyperdrive = "hyperdrive",
  prognosis = "prognosis",
  green = "green",
  screentime = "screentime",
  citylab = "citylab",
  wealth = "wealth",
  equality = "equality",
  syndication = "syndication",
  newsletters = "newsletters",
  economics = "economics",
  crypto = "crypto",
  "markets-magazine" = "markets-magazine",
  industries = "industries",
  "work-shift" = "work-shift",
  "weekend-edition" = "weekend-edition",
}

export enum DaperStoryType {
  article = "article",
  audio = "audio",
  photo = "photo",
  breaking_news = "breaking_news",
  data_article = "data_article",
  slideshow = "slideshow",
  impact_scorecard = "impact_scorecard",
  interactive = "interactive",
  feature = "feature",
  quicktake = "quicktake",
  video = "video",
  letter = "letter",
  newsletter_campaign = "newsletter_campaign",
  author_session = "author_session",
  storythread = "storythread",
  liveblog = "liveblog",
  explainers = "explainers",
}

export enum DaperStoryBrand {
  bview = "bview",
  gadfly = "gadfly",
  quicktake = "quicktake",
  bbiz = "bbiz",
  bpol = "bpol",
  businessweek = "businessweek",
  markets = "markets",
  technology = "technology",
  pursuits = "pursuits",
  cojp = "cojp",
  sponsored = "sponsored",
  green = "green",
  citylab = "citylab",
  wealth = "wealth",
  equality = "equality",
  economics = "economics",
  industries = "industries",
  crypto = "crypto",
  "work-shift" = "work-shift",
  "markets-magazine" = "markets-magazine",
}

export enum DaperLocale {
  en = "en",
  ja = "ja",
}

export enum DaperImageIdType {
  AVMM = "AVMM",
  BMMR = "BMMR",
  OOYALA = "OOYALA",
}

export enum DaperTimeRangeUnits {
  minute = "minute",
  hour = "hour",
  week = "week",
  month = "month",
  year = "year"
}
